import React, { useEffect, useState } from "react";
import { Modal, Table, Button, Toast } from "react-bootstrap";
import { format } from "date-fns";
import { FaEye } from "react-icons/fa";

const GlobalBirthdaysNotification = () => {
  const [birthdays, setBirthdays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchBirthdays = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/admin/analytics/upcoming-birthdays`,
          {
            credentials: "include",
          }
        );
        if (response.ok) {
          const data = await response.json();
          setBirthdays(data);
          if (data.length > 0) {
            setShowNotification(true); // Показать уведомление, если есть дни рождения
          }
        } else {
          setError("Ошибка загрузки данных");
        }
      } catch (error) {
        setError("Ошибка соединения с сервером");
      } finally {
        setLoading(false);
      }
    };

    fetchBirthdays();
  }, []);

  const handleViewDetails = () => {
    setShowNotification(false);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  if (loading) {
    return null; // Пока данные загружаются, уведомление не показывается
  }

  if (error || birthdays.length === 0) {
    return null; // Если есть ошибка или дни рождения отсутствуют, уведомление не показывается
  }

  return (
    <>
      {/* Уведомление */}
      {showNotification && (
        <Toast
          onClose={() => setShowNotification(false)}
          className="position-fixed bottom-0 end-0 m-3 bg-primary text-white"
          style={{ zIndex: 1055 }}
        >
          <Toast.Header>
            <strong className="me-auto">Напоминание</strong>
            <small>Сейчас</small>
          </Toast.Header>
          <Toast.Body>
            У ближайших партнёров скоро день рождения!
            <Button
              variant="light"
              size="sm"
              onClick={handleViewDetails}
              className="mt-2 w-100"
            >
              Посмотреть
            </Button>
          </Toast.Body>
        </Toast>
      )}

      {/* Модальное окно */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Ближайшие дни рождения партнёров</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Имя партнёра</th>
                <th>Дата рождения</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {birthdays.map((partner, index) => (
                <tr key={partner.unique_id}>
                  <td>{index + 1}</td>
                  <td>{partner.name}</td>
                  <td>{format(new Date(partner.birthday), "dd.MM.yyyy")}</td>
                  <td className="text-center">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() =>
                        window.open(
                          `/admin/partner/${partner.unique_id}`,
                          "_blank"
                        )
                      }
                    >
                      <FaEye />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Закрыть
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GlobalBirthdaysNotification;
